import { render, staticRenderFns } from "./kuangchi.vue?vue&type=template&id=59536450&scoped=true"
import script from "./kuangchi.vue?vue&type=script&lang=js"
export * from "./kuangchi.vue?vue&type=script&lang=js"
import style0 from "./kuangchi.vue?vue&type=style&index=0&id=59536450&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59536450",
  null
  
)

export default component.exports